import { ErrorBoundary } from "react-error-boundary"

import { LandingPageNavbar } from "../../components"
import { ErrorFallbackMessage } from "../../components/common"

const CreateAccountLayout = ({ children }) => {
  return (
    <div style={{ position: "relative", overflow: "hidden", maxWidth: "100%" }}>
      <LandingPageNavbar
        showNavbarArt={false}
        showBackground={true}
        signUpUrl={"/create-account"}
        loginUrl={"/login"}
      />
      <ErrorBoundary
        fallback={<ErrorFallbackMessage />}
      />
      {children}
    </div>
  )
}

export default CreateAccountLayout
